import { Close } from "@mui/icons-material";
import { useParams } from "@tanstack/react-router";

import { IconButtonLink } from "../Links";

export const CloseButton = () => {
  const routeParams = useParams({
    from: "/gym/$venueUuid/schedule/set/$setUuid/$taskUuid",
  });
  return (
    <IconButtonLink
      to="/gym/$venueUuid/schedule/set/$setUuid"
      replace
      params={{
        venueUuid: routeParams.venueUuid,
        setUuid: routeParams.setUuid,
      }}
      sx={{
        position: "absolute",
        backgroundColor: "#01002499",
        top: 8,
        right: 8,
        border: "1px solid",
        borderColor: "#343F6599",
        borderRadius: "100%",
        zIndex: 10,
        "&:hover": {
          backgroundColor: "neutral.800",
        },
      }}
    >
      <Close sx={{ color: "white" }} />
    </IconButtonLink>
  );
};
